module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bubbletextafteraction":"Tap the microphone button, to ask me a question."},"es":{"bubbletextafteraction":"Toca el botón del micrófono, para preguntarme algo."}}')
  delete Component.options._Ctor
}
